import { Box } from "@mantine/core";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";

import * as classes from "./PortfolioMarquee.module.css";

const row1Images = [
  <StaticImage
    src="../../images/portfolio/featured-act-cel.jpg"
    alt="ACT CEL"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-act-work-ready-communities.jpg"
    alt="ACT Work Ready Communities"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-act-work-ready-communities.jpg"
    alt="ACT Work Ready Communities Secondary"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-center-for-equity-in-learning.jpg"
    alt="Center for Equity in Learning"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-asbn-coworks.jpg"
    alt="ASBN Coworks"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-autotrader-specialty.jpg"
    alt="AutoTrader Specialty"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-autotrader-specialty.png"
    alt="AutoTrader Specialty Secondary"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-b2b-autotrader.jpg"
    alt="B2B AutoTrader"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-b2b.autotrader.jpg"
    alt="B2B AutoTrader Secondary"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-b2b-kbb.jpg"
    alt="B2B KBB"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-b2b.kbb_.jpg"
    alt="B2B KBB Secondary"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-central-dispatch.jpg"
    alt="Central Dispatch"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-central-dispatch.jpg"
    alt="Central Dispatch Secondary"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-childrens-hospital.jpg"
    alt="Children's Hospital"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-cricket-ad-builder.jpg"
    alt="Cricket Ad Builder"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-cricket.jpg"
    alt="Cricket Secondary"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-element-at-manheim.jpg"
    alt="Element at Manheim"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-element.jpg"
    alt="Element Secondary"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-fire-service-plus.jpg"
    alt="Fire Service Plus"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-georgia-head-start.jpg"
    alt="Georgia Head Start"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-gordos-cheese-dip.jpg"
    alt="Gordo's Cheese Dip"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-h-e-parts.jpg"
    alt="H&E Parts"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-hidden-links.jpg"
    alt="Hidden Links"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-lackmond.jpg"
    alt="Lackmond"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-lawn-dart.jpg"
    alt="Lawn Dart"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-lawn-dart.jpg"
    alt="Lawn Dart Secondary"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-mamheim-auctions.jpg"
    alt="Manheim Auctions"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
];

const row2Images = [
  <StaticImage
    src="../../images/portfolio/featured-mimaki.jpg"
    alt="Mimaki"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-monarch-private-capital.jpg"
    alt="Monarch Private Capital"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-monarch-private-capital.jpg"
    alt="Monarch Private Capital Secondary"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-mr-mister.jpg"
    alt="Mr. Mister"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-mymanheim.jpg"
    alt="MyManheim"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-mymanheim.jpg"
    alt="MyManheim Secondary"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-navicent-health.jpg"
    alt="Navicent Health"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-atrium-navicent-health.jpg"
    alt="Atrium Navicent Health"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-newbridge-group.jpg"
    alt="New Bridge Group"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-o4d.jpg"
    alt="O4D"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-o4d.jpg"
    alt="O4D Secondary"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-pattillo.jpg"
    alt="Pattillo"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-real-advisory.jpg"
    alt="Real Advisory"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-rest.jpg"
    alt="REST"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-river-sand-inc.jpg"
    alt="River Sand Inc"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-rsi.jpg"
    alt="River Sand Inc Secondary"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-ronnie-thames.jpg"
    alt="Ronnie Thames"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-sacs-coc.jpg"
    alt="SACS COC"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-smith-currie.jpg"
    alt="Smith Currie"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-steve-dennis.jpg"
    alt="Steve Dennis"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/feature-secondary-camp360.jpg"
    alt="Camp360"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-true-weather.jpg"
    alt="True Weather"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
  <StaticImage
    src="../../images/portfolio/featured-vitalyon.jpg"
    alt="Vitalyon"
    placeholder="blurred"
    layout="fixed"
    height={200}
    objectFit="contain"
    objectPosition="center"
  />,
];

export function PortfolioMarquee() {
  return (
    <Box className={classes.marqueeWrapper}>
      <Box className={classes.marqueeContainer}>
        <Box className={classes.gradientLeft} />
        <Box className={classes.gradientRight} />

        <Box className={classes.marqueeRow}>
          <Box className={classes.marqueeContent}>
            {[...Array(4)].map((_, groupIndex) => (
              <Box
                key={`row1-group-${groupIndex}`}
                className={classes.marqueeTrack}
              >
                {row1Images.map((image, index) => (
                  <Box
                    key={`row1-image-${groupIndex}-${index}`}
                    className={classes.imageItem}
                  >
                    {image}
                  </Box>
                ))}
              </Box>
            ))}
          </Box>
        </Box>

        <Box className={classes.marqueeRow}>
          <Box
            className={`${classes.marqueeContent} ${classes.marqueeContentOffset}`}
          >
            {[...Array(4)].map((_, groupIndex) => (
              <Box
                key={`row2-group-${groupIndex}`}
                className={classes.marqueeTrack}
              >
                {row2Images.map((image, index) => (
                  <Box
                    key={`row2-image-${groupIndex}-${index}`}
                    className={classes.imageItem}
                  >
                    {image}
                  </Box>
                ))}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
